import parseFile from "lib/parseFile";
import obj2event from "lib/obj2event";

export default function DropHandler(actions) {
    const {addChart, expose, selectChart, removeDataset, insertDataset} = actions;

    const handleFile = function(file) {
        let reader = new FileReader();
        reader.addEventListener("load", function(e) {
            let name = "file:" + file.name,
                title = file.name,
                rawData = e.target.result;

            const conf = {title, dataset: name, type: "BarChart"};

            removeDataset(name);

            try {
                let events = parseFile(rawData).map(obj2event());
                insertDataset(name, events);
            } catch (err) {
                window.alert("could not parse file " + name);
                expose(false);
                return;
            }

            expose(false);
            try {
                selectChart({dataset: name});
            } catch (err) {
                addChart(conf, true);
            }
        });

        reader.readAsText(file);
    };


    const handleURL = function(url) {
        const conf = {type: "BarChart", title: url, dataset: url};

        addChart(conf);
        selectChart(conf);
        expose(false);
    };


    return (data) => {
        // json /csv file -> insert data and create chart
        // json/csv/event-stream url -> create chart with the url

        if (data.files.length > 0) {
            for (let i = 0; i < data.files.length; i++) {
                handleFile(data.files[i]);
            }
        } else {
            const text = data.getData("text");

            if (text) {
                handleURL(text);
            }
        }
    };
}



// WEBPACK FOOTER //
// ./src/kpi/common/DropHandler.js